import { useEffect } from 'react';

export default function useApiEffect(sideEffect, api, dependencies = []) {
  useEffect(() => {
    let mounted = true;
    api(...dependencies).then((result) => {
      if (mounted) sideEffect(result);
    });
    return () => { mounted = false; }
    // eslint-disable-next-line
  }, dependencies);
};
